var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadingDiv"},[(_vm.kiosk && _vm.kiosk.type == 'branded')?_c('KioskBranded',{attrs:{"site":_vm.site,"kioskUUID":_vm.kioskUUID,"s":_vm.shareKiosk}}):_vm._e(),(_vm.kiosk && _vm.kiosk.type !== 'branded')?_c('Kiosk',{attrs:{"kioskUUID":_vm.kioskUUID,"site":_vm.site,"s":_vm.shareKiosk}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }